import { IAppStore } from '@models/store.model'
import { Button, InputLabel, Typography } from '@mui/material'
import { webApiService } from '@services/index'
import { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useSelector } from 'react-redux'
import * as XLSX from 'xlsx'
import Divider from '@mui/material/Divider'
import MUIDataTable from 'mui-datatables'

const columns = [
  {
    name: 'id',
    label: 'ID',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'name',
    label: 'Name',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'sku',
    label: 'Sku',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'category',
    label: 'Categoria',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'variant_color',
    label: 'Variante ó Color',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'family',
    label: 'Familia',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'subfamily',
    label: 'Sub Familia',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'inventory',
    label: 'Inventario',
    options: {
      filter: true,
      sort: true,
      display: true
    }
  }
]

const MassAddSupplyPage = () => {
  const [data, setData] = useState<{ loading: boolean, listOt: any[], html: string, supplies: any[]}>({ loading: false, listOt: [], html: '', supplies: [] })
  const userState = useSelector((store: IAppStore) => store.user)
  const [supplies, setSupplies] = useState<any[]>([])

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const validFiles = acceptedFiles.filter(file =>
      ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type)
    )
    console.log('🚀 ~ onDrop ~ validFiles:', validFiles)

    // Asegúrate de que 'files' es de tipo 'File[]'
    const reader = new FileReader()
    reader.onload = (e) => {
      const _data = e.target?.result
      const workbook = XLSX.read(_data, { type: 'binary' })
      console.log(workbook.SheetNames)
      const rowObject : any[] = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])

      setData({ ...data, listOt: rowObject })
      console.log('🚀 ~ readExcel ~ rowObject', rowObject)
    }
    // file to blob type
    reader.readAsBinaryString(validFiles[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
    maxFiles: 1,
    maxSize: (process.env.VITE_MAXFILESIZE !== undefined) ? parseInt(process.env.VITE_MAXFILESIZE) : 2097152,
    accept: {
      'application/vnd.ms-excel': ['.xlsx'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onDrop
  })

  const massAddSupply = async () => {
    setData({ ...data, loading: true })
    let html = '----- INICIO -----<br/>'
    for (const item of data.listOt) {
      const objResolution = {
        ot: item.OT,
        sku: item.SKU_INSUMO,
        cantidad: item.CANTIDAD,
        updated_by: userState.id
      }
      console.log('🚀 ~ sendMails ~ objTradeIn:', objResolution)
      // eslint-disable-next-line no-loop-func
      await webApiService.massAddSupply(objResolution).then((res) => {
        console.log('🚀 ~ awaitwebApiService.AssignTech ~ res:', res)
        html += '<p>' + item.OT + ' - ' + res.data + '</p>'
        // eslint-disable-next-line no-loop-func
      }).catch((err) => {
        console.log('🚀 ~ awaitwebApiService.sendMails ~ err:', err)
        html += '<p>' + item['Po Id'] + ' - ' + err.response.data.message + '</p>'
      })
      setData({ ...data, html, loading: true })
    }
    html += '----- FIN -----<br/>'
    setData({ ...data, loading: false, html })
  }

  const loadData = () => {
    webApiService.getSuppliesList().then((response) => {
      setSupplies(response.data.filter((item: any) => item.sku !== ''))
    }).catch((error) => {
      console.log(error)
    })
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <div className='container-xxl '>
        <div className='row gy-3 my-4'>
          <div className='col-12 my-2'>
            <Typography variant='h6' className='title mb-3'>
              ASIGNAR INSUMOS
            </Typography>

            <div className='shadow-sm rounded bg-white p-3'>
              <div className='text-end'>
                <Button
                  variant='contained'
                  color='primary'
                  className='mb-2'
                  href='/Plantilla_Asignacion_Insumo.xlsx'
                >
                  Descargar plantilla tipo
                </Button>
              </div>
              <InputLabel id='demo-simple-select-label'>Excel con listado de ordenes e insumos para asignar:</InputLabel>
              <div hidden={data.listOt.length > 0} {...getRootProps({ className: isDragAccept ? 'p-5 dropzone dropzone-accept' : isDragReject ? 'p-5 dropzone dropzone-reject' : 'p-5 dropzone' })}>
                <input {...getInputProps()} />
                <div className='alert alert-danger text-center p-3' role='alert'>
                  <p>El archivo que esta intentando adjuntar no esta permitido</p>
                  <hr />
                  <p className='mb-0 small'>* Archivos permitido es: <strong>XLSX</strong></p>
                </div>
                <div className='text-center instrucciones'>

                  <Button
                    variant='contained'
                    size='medium'
                    color='secondary'
                    className='m-2'
                  >
                    Seleccione archivo
                  </Button>
                  <p className='mt-3 mb-0'><strong>Haga click para subir el archivo</strong> o arrastre y suelte aquí.</p>
                  <p>XLSX (tamaño máximo 2 mb)</p>
                </div>
              </div>
              {data.listOt.map((item: any, idx: number) => {
                return (<span key={idx} className='badge rounded-pill text-bg-secondary me-1'>{item.ot}</span>)
              })}
              <div hidden={data.listOt.length === 0}>
                <Button size='small' onClick={() => { setData({ ...data, listOt: [] }) }}> Cargar excel nuevamente</Button>
              </div>
              <div className='text-end'>
                <Button
                  variant='contained'
                  color='primary'
                  className='mt-2'
                  onClick={() => { massAddSupply() }}
                  disabled={data.listOt.length === 0 || data.loading}
                >
                  Guardar
                </Button>
              </div>
              <div className={data.html === '' ? 'bg-black p-0 text-white mt-2' : 'bg-black p-2 text-white mt-2'} dangerouslySetInnerHTML={{ __html: data.html }} />
              <Divider className='my-2' />
              <div>
                <h6 className='fw-bold'>Buscador de SKU de insumo</h6>
                <MUIDataTable
                  title=''
                  data={supplies}
                  columns={columns}
                  options={{ print: false, viewColumns: false, filter: false, selectableRowsHideCheckboxes: true }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MassAddSupplyPage
